<!-- =========================================
     SANGEETHA TOYS — LOGIN / REGISTER PAGE
     Reference: White card, Login/Register tabs,
     social login buttons, clean blue theme
========================================= -->

<app-navbar-style-two></app-navbar-style-two>

<!-- ── PAGE SPACER (below sticky navbar) ── -->
<div class="auth-spacer" aria-hidden="true"></div>

<!-- ═══════════════════════════════════════
     FULL PAGE AUTH LAYOUT
═══════════════════════════════════════ -->
<section class="auth-page">

  <!-- Decorative background blobs -->
  <div class="auth-page__bg" aria-hidden="true">
    <span class="auth-blob b1"></span>
    <span class="auth-blob b2"></span>
    <span class="auth-blob b3"></span>
    <span class="auth-emoji ae1">🧸</span>
    <span class="auth-emoji ae2">🚀</span>
    <span class="auth-emoji ae3">⭐</span>
    <span class="auth-emoji ae4">🎨</span>
    <span class="auth-emoji ae5">🎁</span>
  </div>

  <div class="container">
    <div class="auth-row">

      <!-- ══ LEFT PANEL — Brand info ══ -->
      <div class="auth-brand-panel">

        <div class="auth-brand-panel__inner">

          <!-- Logo area -->
          <a routerLink="/" class="auth-brand-panel__logo" aria-label="Sangeetha Toys Home">
            <img src="assets/img/slider/mainlogo.png" alt="Sangeetha Toys Logo">
          </a>

          <h2 class="auth-brand-panel__title">
            Welcome to<br>
            <span>Sangeetha Toys!</span> 🎉
          </h2>

          <p class="auth-brand-panel__desc">
            Discover thousands of safe, fun and educational toys
            for children of all ages. Shop with confidence — quality guaranteed.
          </p>

          <!-- Feature list -->
          <ul class="auth-brand-panel__features">
            <li>
              <span class="abp-check"><i class='bx bx-check'></i></span>
              100% safe, child-tested products
            </li>
            <li>
              <span class="abp-check"><i class='bx bx-check'></i></span>
              Fast &amp; secure doorstep delivery
            </li>
            <li>
              <span class="abp-check"><i class='bx bx-check'></i></span>
              Easy returns &amp; friendly support
            </li>
            <li>
              <span class="abp-check"><i class='bx bx-check'></i></span>
              1000+ happy customers &amp; 4.8★ rated
            </li>
          </ul>

          <!-- Stats strip -->
          <div class="auth-brand-panel__stats">
            <div class="abp-stat">
              <strong>1000+</strong>
              <span>Customers</span>
            </div>
            <div class="abp-stat-divider" aria-hidden="true"></div>
            <div class="abp-stat">
              <strong>500+</strong>
              <span>Products</span>
            </div>
            <div class="abp-stat-divider" aria-hidden="true"></div>
            <div class="abp-stat">
              <strong>4.8★</strong>
              <span>Rating</span>
            </div>
          </div>

          <!-- Decorative toy image -->
          <div class="auth-brand-panel__toy" aria-hidden="true">
            <img src="assets/img/slider/login-img2.png"
                 onerror="this.style.display='none'"
                 alt="">
          </div>

        </div>

      </div>

      <!-- ══ RIGHT PANEL — Auth forms ══ -->
      <div class="auth-card-panel">

        <!-- ── LOGIN / REGISTER TABS ── -->
        <!-- <div class="auth-tabs" role="tablist" aria-label="Authentication options">
          <button
            type="button"
            class="auth-tab"
            [class.auth-tab--active]="activeTab === 'login'"
            (click)="activeTab = 'login'"
            role="tab"
            [attr.aria-selected]="activeTab === 'login'">
            Login
          </button>
          <button
            type="button"
            class="auth-tab"
            [class.auth-tab--active]="activeTab === 'register'"
            (click)="activeTab = 'register'"
            role="tab"
            [attr.aria-selected]="activeTab === 'register'">
            Register
          </button>
        </div> -->

        <!-- ════════════════════
             LOGIN FORM
        ════════════════════ -->
        <div class="auth-form-wrap" *ngIf="activeTab === 'login'" role="tabpanel">

          <div class="auth-form-header">
            <h2>Welcome Back!</h2>
            <p>Login to continue shopping with Sangeetha Toys!</p>
          </div>

          <form [formGroup]="loginForm" (ngSubmit)="login()" novalidate>

            <!-- Email / Phone -->
            <div class="af-group">
              <label for="login-username">
                <i class='bx bx-user'></i>
                Email or Phone
              </label>
              <div class="af-input-wrap">
                <i class='bx bx-user af-input-icon'></i>
                <input
                  id="login-username"
                  type="text"
                  class="af-input"
                  formControlName="username"
                  placeholder="Enter your email or phone">
              </div>
              <div class="af-error"
                   *ngIf="loginForm.get('username')?.touched && loginForm.get('username')?.invalid">
                <small *ngIf="loginForm.get('username')?.errors?.['required']">Username is required.</small>
                <small *ngIf="loginForm.get('username')?.errors?.['minlength']">Minimum 3 characters required.</small>
              </div>
            </div>

            <!-- Password -->
            <div class="af-group">
              <label for="login-password">
                <i class='bx bx-lock-alt'></i>
                Password
              </label>
              <div class="af-input-wrap">
                <i class='bx bx-lock-alt af-input-icon'></i>
                <input
                  id="login-password"
                  type="password"
                  class="af-input"
                  formControlName="password"
                  placeholder="Enter your password">
              </div>
              <div class="af-error"
                   *ngIf="loginForm.get('password')?.touched && loginForm.get('password')?.invalid">
                <small *ngIf="loginForm.get('password')?.errors?.['required']">Password is required.</small>
                <small *ngIf="loginForm.get('password')?.errors?.['minlength']">Minimum 6 characters required.</small>
              </div>
            </div>

            <!-- Remember me + Forgot -->
            <div class="af-row-between">
              <label class="af-checkbox">
                <input type="checkbox">
                <span class="af-checkmark"></span>
                Remember me
              </label>
              <a href="javascript:void(0)"
                 class="af-link af-link--forgot"
                 (click)="activeTab = 'forgot-password'">
                Forgot Password?
              </a>
            </div>

            <!-- Submit -->
            <button type="submit"
                    class="af-submit-btn"
                    [disabled]="loginForm.invalid">
              Login
            </button>

            <!-- Divider -->
            <!-- <div class="af-divider">
              <span>Or continue with</span>
            </div> -->

            <!-- Social buttons -->
            <!-- <div class="af-social-row">
              <button type="button" class="af-social-btn af-social-btn--google">
                <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
                  <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                  <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17z"/>
                  <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07z"/>
                  <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.31z"/>
                </svg>
                Google
              </button>
              <button type="button" class="af-social-btn af-social-btn--facebook">
                <i class='bx bxl-facebook'></i>
                Facebook
              </button>
            </div> -->

            <!-- Switch -->
            <p class="af-switch">
              Don't have an account?
              <a href="javascript:void(0)" (click)="activeTab = 'register'">Register Now</a>
            </p>

          </form>

        </div>

        <!-- ════════════════════
             REGISTER FORM
        ════════════════════ -->
        <div class="auth-form-wrap" *ngIf="activeTab === 'register'" role="tabpanel">

          <div class="auth-form-header">
            <h2>Create Account</h2>
            <p>Join Sangeetha Toys and discover amazing toys for your little ones!</p>
          </div>

          <form [formGroup]="registerForm" (ngSubmit)="register()" novalidate>

            <!-- Username -->
            <div class="af-group">
              <label for="reg-username"><i class='bx bx-user'></i> Username</label>
              <div class="af-input-wrap">
                <i class='bx bx-user af-input-icon'></i>
                <input id="reg-username" type="text" class="af-input"
                       formControlName="username" placeholder="Choose a username">
              </div>
              <div class="af-error"
                   *ngIf="registerForm.get('username')?.touched && registerForm.get('username')?.invalid">
                <small *ngIf="registerForm.get('username')?.errors?.['required']">Username is required.</small>
                <small *ngIf="registerForm.get('username')?.errors?.['minlength']">Minimum 3 characters required.</small>
              </div>
            </div>

            <!-- Mobile -->
            <div class="af-group">
              <label for="reg-mobile"><i class='bx bx-phone'></i> Mobile Number</label>
              <div class="af-input-wrap">
                <i class='bx bx-phone af-input-icon'></i>
                <input id="reg-mobile" type="text" class="af-input"
                       formControlName="mobile" placeholder="10-digit mobile number">
              </div>
              <div class="af-error"
                   *ngIf="registerForm.get('mobile')?.touched && registerForm.get('mobile')?.invalid">
                <small *ngIf="registerForm.get('mobile')?.errors?.['required']">Mobile number is required.</small>
                <small *ngIf="registerForm.get('mobile')?.errors?.['pattern']">Enter a valid 10-digit number.</small>
              </div>
            </div>

            <!-- Email -->
            <div class="af-group">
              <label for="reg-email"><i class='bx bx-envelope'></i> Email</label>
              <div class="af-input-wrap">
                <i class='bx bx-envelope af-input-icon'></i>
                <input id="reg-email" type="email" class="af-input"
                       formControlName="email" placeholder="Enter your email">
              </div>
              <div class="af-error"
                   *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.invalid">
                <small *ngIf="registerForm.get('email')?.errors?.['required']">Email is required.</small>
                <small *ngIf="registerForm.get('email')?.errors?.['email']">Enter a valid email address.</small>
              </div>
            </div>

            <!-- Password -->
            <div class="af-group">
              <label for="reg-password"><i class='bx bx-lock-alt'></i> Password</label>
              <div class="af-input-wrap">
                <i class='bx bx-lock-alt af-input-icon'></i>
                <input id="reg-password" type="password" class="af-input"
                       formControlName="password" placeholder="Create a strong password">
              </div>
              <div class="af-error"
                   *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.invalid">
                <small *ngIf="registerForm.get('password')?.errors?.['required']">Password is required.</small>
                <small *ngIf="registerForm.get('password')?.errors?.['minlength']">Minimum 8 characters required.</small>
                <small *ngIf="registerForm.get('password')?.errors?.['pattern']">Must include uppercase, lowercase, number &amp; special character.</small>
              </div>
            </div>

            <!-- Confirm Password -->
            <div class="af-group">
              <label for="reg-confirm"><i class='bx bx-lock-open-alt'></i> Confirm Password</label>
              <div class="af-input-wrap">
                <i class='bx bx-lock-open-alt af-input-icon'></i>
                <input id="reg-confirm" type="password" class="af-input"
                       formControlName="confirmPassword" placeholder="Re-enter your password">
              </div>
              <div class="af-error"
                   *ngIf="registerForm.touched && registerForm.errors?.['passwordMismatch']">
                <small>Passwords do not match.</small>
              </div>
            </div>

            <!-- Password hint -->
            <p class="af-hint">
              <i class='bx bx-info-circle'></i>
              Use at least 8 characters with uppercase, lowercase, numbers &amp; symbols.
            </p>

            <!-- Submit -->
            <button type="submit"
                    class="af-submit-btn"
                    [disabled]="registerForm.invalid">
              Create Account
            </button>

            <!-- Divider -->
            <!-- <div class="af-divider"><span>Or continue with</span></div> -->

            <!-- Social -->
            <!-- <div class="af-social-row">
              <button type="button" class="af-social-btn af-social-btn--google">
                <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
                  <path fill="#4285F4" d="M16.51 8H8.98v3h4.3c-.18 1-.74 1.48-1.6 2.04v2.01h2.6a7.8 7.8 0 002.38-5.88c0-.57-.05-.66-.15-1.18z"/>
                  <path fill="#34A853" d="M8.98 17c2.16 0 3.97-.72 5.3-1.94l-2.6-2a4.8 4.8 0 01-7.18-2.54H1.83v2.07A8 8 0 008.98 17z"/>
                  <path fill="#FBBC05" d="M4.5 10.52a4.8 4.8 0 010-3.04V5.41H1.83a8 8 0 000 7.18l2.67-2.07z"/>
                  <path fill="#EA4335" d="M8.98 4.18c1.17 0 2.23.4 3.06 1.2l2.3-2.3A8 8 0 001.83 5.4L4.5 7.49a4.77 4.77 0 014.48-3.31z"/>
                </svg>
                Google
              </button>
              <button type="button" class="af-social-btn af-social-btn--facebook">
                <i class='bx bxl-facebook'></i>
                Facebook
              </button>
            </div> -->

            <!-- Switch -->
            <p class="af-switch">
              Already have an account?
              <a href="javascript:void(0)" (click)="activeTab = 'login'">Sign In</a>
            </p>

          </form>

        </div>

        <!-- ════════════════════
             FORGOT PASSWORD
        ════════════════════ -->
        <div class="auth-form-wrap" *ngIf="activeTab === 'forgot-password'" role="tabpanel">

          <div class="auth-form-header">
            <div class="af-back-btn" (click)="activeTab = 'login'" role="button" tabindex="0"
                 aria-label="Back to login">
              <i class='bx bx-arrow-back'></i> Back to Login
            </div>
            <h2>Forgot Password?</h2>
            <p>Enter your registered email and we'll send you a reset link.</p>
          </div>

          <!-- Illustration -->
          <div class="af-forgot-icon" aria-hidden="true">🔐</div>

          <form [formGroup]="forgotPasswordForm" (ngSubmit)="forgotPassword()" novalidate>

            <div class="af-group">
              <label for="forgot-email"><i class='bx bx-envelope'></i> Email Address</label>
              <div class="af-input-wrap">
                <i class='bx bx-envelope af-input-icon'></i>
                <input id="forgot-email" type="email" class="af-input"
                       formControlName="email" placeholder="Enter your registered email">
              </div>
              <div class="af-error"
                   *ngIf="forgotPasswordForm.get('email')?.touched && forgotPasswordForm.get('email')?.invalid">
                <small *ngIf="forgotPasswordForm.get('email')?.errors?.['required']">Email is required.</small>
                <small *ngIf="forgotPasswordForm.get('email')?.errors?.['email']">Enter a valid email.</small>
              </div>
            </div>

            <button type="submit"
                    class="af-submit-btn"
                    [disabled]="forgotPasswordForm.invalid">
              <i class='bx bx-send'></i>
              Send Reset Link
            </button>

            <p class="af-switch">
              Remembered your password?
              <a href="javascript:void(0)" (click)="activeTab = 'login'">Login Now</a>
            </p>

          </form>

        </div>

      </div><!-- /auth-card-panel -->

    </div><!-- /auth-row -->
  </div>

</section>